import { Box, Grid } from '@mui/material';
import { useEffect, useRef } from 'react';
import Title from '/@/components/title';
import settings from '/@/core/settings';
import { _, _lazy } from '/@/locale';
import Select from '/@/v3/components/forms/select';
import ProductList from './product-list';
import styles from './styles.module.css';

function ProductSelection(props) {
    const {
        brand,
        cropConfig,
        featuredProducts,
        otherProducts,
        metricChoices,
        onToggle,
        onMetricChange,
        loading,
        country,
        recommendation,
    } = props;

    const ref = useRef(null);

    useEffect(() => {
        if (cropConfig?.products?.length > 0) ref.current?.scrollIntoView({ behavior: 'smooth' });
    }, [cropConfig?.products?.length]);

    return (
        <Box sx={{ py: 4 }} ref={ref}>
            <div className={styles.root}>
                <div className={styles.section}>
                    <div className={styles.header}>
                        <Grid container direction='column' spacing={2}>
                            <Grid item>
                                <Title>{_('Selección de productos')}</Title>
                            </Grid>
                            <Grid item>
                                <p>{_('Seleccioná hasta 3 productos para obtener las recomendaciones específicas.')}</p>
                            </Grid>
                        </Grid>
                        {metricChoices.length > 0 && (
                            <div>
                                <Select
                                    color={settings.app.theme}
                                    persistPlaceholder
                                    placeholder={
                                        brand.type === 'soy' ? _('Ver perfil fitosanitario') : _('Ver perfil defensivo')
                                    }
                                    clearable
                                    clearLabel={_('Ninguna')}
                                    onChange={onMetricChange}
                                    value={cropConfig[`${cropConfig.crop}Metric`]}
                                    options={metricChoices.map(({ id, name }) => ({ value: id, label: _(name) }))}
                                />
                            </div>
                        )}
                    </div>
                    <ProductList
                        featuredProducts={featuredProducts}
                        otherProducts={otherProducts}
                        selectedIds={cropConfig['products']}
                        plantingDate={cropConfig.plantingDate}
                        metric={cropConfig[`${cropConfig.crop}Metric`]}
                        showEstimatedYield={brand.showEstimatedYieldInProductSelection}
                        showShortDescription={brand.showShortDescriptionInProductSelection}
                        showPlantingDates={featuredProducts.some((product) => (product.plantingDates || []).length > 0)}
                        onToggle={onToggle}
                        loading={loading}
                        showDefensiveProfile={brand.type === 'corn'}
                        country={country}
                        recommendation={recommendation}
                    />
                </div>
            </div>
        </Box>
    );
}

ProductSelection.menuLabel = _lazy('Selección de productos');
ProductSelection.displayName = 'ProductSelection';

export default ProductSelection;
